/* istanbul ignore file */
export * from './banner.component';
